import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { MasterTyreService } from 'src/app/share/services/master-tyre/master-tyre.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { MessageService } from '../../share/sharedsubject';

@Component({
    selector: 'app-add-master-data',
    templateUrl: './add-master-data.component.html',
    styleUrls: ['./add-master-data.component.scss'],
    standalone: false
})
export class AddMasterDataComponent implements OnInit {
  addTyreForm: FormGroup;
  isLoading = false;
  brandName: string = '';
  responseMsg: string;
  selecteTyreId: any;
  isAdmin: boolean;
  vehicleFormats: any = [
    { id: '4 wheeler', name: 'Car' },
    { id: 'LCV/Truck', name: 'LCV / Truck' },
    { id: '2 wheeler/3 wheeler', name: '2 Wheeler / 3 Wheeler' },
    { id: 'OTR/Tractor/Adv', name: 'Tractor / OTR / ADV' },
  ]

  visibleFields: any = {
    rimSize: { visible: false, required: false },
    aspectRatio: { visible: false, required: false },
    constructionType: { visible: false, required: false },
    crossSectionWidth: { visible: false, required: false },
    commercialTyre: { visible: false, required: false },
    profile: { visible: false, required: false },
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterTyreService: MasterTyreService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly messageService: MessageService
  ) {
    this.addTyreForm = this.formBuilder.group({
      category: ['', [Validators.required]],
      tyreSize: [''],
      rimSize: [''],
      aspectRatio: [''],
      constructionType: [''],
      speedSymbol: [''],
      crossSectionWidth: [''],
      minAmount: [''],
      maxAmount: [''],
      profitability: [''],
      profile: [''],
    });
  }

  ngOnInit() {
    let selfDetailsData = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (selfDetailsData) {
      this.isAdmin = selfDetailsData.enrollmentType === 'Admin';
    }
    this.activatedRoute.queryParams.subscribe((res) => {
      this.selecteTyreId = res['tId'];
    });
    if (this.selecteTyreId) {
      if (this.isAdmin) {
        this.getAdminTyreDetailsByTyreId();
      } else {
        this.getTyreDetailsById();
      }
    }
  }

  getTyreDetailsById() {
    this.masterTyreService
      .getTyreDetailsByTyreId(this.selecteTyreId)
      .subscribe((res) => {
        this.addTyreForm.patchValue(res.data);
        this.getFieldsVisibility(res.data.category)
      });
  }

  getAdminTyreDetailsByTyreId() {
    this.masterTyreService
      .getAdminTyreDetailsByTyreId(this.selecteTyreId)
      .subscribe((res) => {
        this.addTyreForm.patchValue(res.data);
        this.getFieldsVisibility(res.data.category)
      });
  }

  getFieldsVisibility(tyre:string) {
    switch (tyre) {
      case '4 wheeler':
        this.buildCarVisibilityFields();
        break;
      case 'LCV/Truck':
        this.buildLCVVisibilityFields();
        break;
      case '2 wheeler/3 wheeler':
        this.buildTwoWheelerVisibilityFields();
        break;
      case 'OTR/Tractor/Adv':
        this.buildTractorVisibilityFields();
        break;
      default:
        this.buildCarVisibilityFields();
        break;
    }
  }

  input(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 1) {
      inputElement.value = inputElement.value.slice(0, 1);
      this.addTyreForm.controls['constructionType'].setValue(inputElement.value);
    }
  }

  commertialInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 1) {
      inputElement.value = inputElement.value.slice(0, 1);
      this.addTyreForm.controls['commercialTyre'].setValue(inputElement.value);
    }
  }

  saveTyreData() {
    this.isLoading = true;
    if (this.selecteTyreId) {
      if (this.isAdmin) {
        this.masterTyreService
          .updateAdminTyreDetails(this.selecteTyreId, this.addTyreForm.value)
          .subscribe({
      next: (res) => {
            setTimeout(() => {
              this.messageService.sendMessage(res.message);
            })
            this.isLoading = false;
            this.router.navigate(['/master-data-list']);
          },
      error: (error) => {
            this.isLoading = false;
            this.responseMsg = error?.error?.error?.message;
          }
    });
      } else {
        this.masterTyreService
          .updateTyreDetails(this.selecteTyreId, this.addTyreForm.value)
          .subscribe({
            next: (res) => {
              setTimeout(() => {
                this.messageService.sendMessage(res.message);
              })
              this.isLoading = false;
              this.router.navigate(['/master-data-list']);
            },
            error: (error) => {
              this.isLoading = false;
              this.responseMsg = error?.error?.error?.message;
            }
          });
      }
    } else {
      this.masterTyreService
        .saveTyreDetails(this.addTyreForm.value)
        .subscribe({
      next: (res: any) => {
          setTimeout(() => {
            this.messageService.sendMessage(res.message);
          })
          this.responseMsg = res.message;
          this.addTyreForm.reset();
        },
      error: (error) => {
          this.responseMsg = error?.error?.error?.message;
        }
    });
    }
  }


  onChangeVehical(event: any) {
    this.responseMsg = '';
    let value = event.target.value;
    switch (value) {
      case '4 wheeler':
        this.buildCarVisibilityFields();
        break;
      case 'LCV/Truck':
        this.buildLCVVisibilityFields();
        break;
      case '2 wheeler/3 wheeler':
        this.buildTwoWheelerVisibilityFields();
        break;
      case 'OTR/Tractor/Adv':
        this.buildTractorVisibilityFields();
        break;
      default:
        this.buildCarVisibilityFields();
        break;
    }
  }


  buildCarVisibilityFields() {
    this.visibleFields = {
      rimSize: { visible: true, required: true },
      aspectRatio: { visible: true, required: true },
      constructionType: { visible: true, required: true },
      crossSectionWidth: { visible: true, required: true },
      commercialTyre: { visible: false, required: false },
      profile: { visible: false, required: false },
    }
    this.updateValidators()
  }

  buildLCVVisibilityFields() {
    this.visibleFields = {
      rimSize: { visible: true, required: true },
      aspectRatio: { visible: false, required: false },
      constructionType: { visible: true, required: true },
      crossSectionWidth: { visible: true, required: true },
      commercialTyre: { visible: true, required: false },
      profile: { visible: true, required: false },
    }
    this.updateValidators()
  }

  buildTwoWheelerVisibilityFields() {
    this.visibleFields = {
      rimSize: { visible: true, required: true },
      aspectRatio: { visible: false, required: false },
      constructionType: { visible: true, required: true },
      crossSectionWidth: { visible: true, required: true },
      commercialTyre: { visible: false, required: false },
      profile: { visible: true, required: false },
    }
    this.updateValidators()
  }

  buildTractorVisibilityFields() {
    this.visibleFields = {
      rimSize: { visible: true, required: true },
      aspectRatio: { visible: true, required: false },
      constructionType: { visible: true, required: true },
      crossSectionWidth: { visible: true, required: true },
      commercialTyre: { visible: false, required: false },
      profile: { visible: false, required: false },
    }
    this.updateValidators()
  }

  updateValidators() {
    Object.keys(this.visibleFields).forEach((field: string) => {
      const control = this.addTyreForm.get(field);

      if (!control) return;
      control.setErrors(null);
      if (this.visibleFields[field].required) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
        control.setValue('');
      }
      control.markAsUntouched();
      control.updateValueAndValidity();
    });
    this.addTyreForm.updateValueAndValidity();
  }


}
